;(function () {
  angular
    .module('contrast.sso')
    .controller(
      'SSOCtrl',
      function (
        $scope,
        $location,
        $translate,
        dialogs,
        csTemplates,
        logger,
        ErrorService,
        SSOFactory,
        preferencesService,
        PREFERENCE_PROPERTIES,
        UserService,
        tsvApiConfig
      ) {
        'ngInject'

        var vm = this,
          changeTemplateUrl =
            'views/superadmin/settings/authentication/change.tpl.html'

        angular.extend(vm, {
          samlEnabledPromise: undefined,
          enabled: false,
          config: null
        })

        angular.extend(vm, {
          revert: revert,
          navigateToAddRoute: navigateToAddRoute
        })

        function init() {
          getSamlEnabled().then(function () {
            if (vm.enabled) {
              getSamlConfig()
            } else {
              $location.path('/pages/403')
            }
          })
        }

        function getSamlEnabled() {
          vm.samlEnabledPromise = preferencesService
            .getBooleanValue(PREFERENCE_PROPERTIES.SAML_ENABLED)
            .then(function (preferenceValue) {
              vm.enabled = preferenceValue
            })

          return vm.samlEnabledPromise
        }

        function getSamlConfig() {
          return SSOFactory.getSAMLConfig().then(function (response) {
            vm.config = response.data.config
          })
        }

        function revert() {
          return csTemplates
            .loadAndInterpolate(changeTemplateUrl, { scope: $scope })
            .then(function (interpolatedStr) {
              var transl = {
                title_changeAuthenticationMethod: $translate.instant(
                  'title_changeAuthenticationMethod'
                ),
                action_changeAuthentication: $translate.instant(
                  'action_changeAuthentication'
                ),
                action_cancel: $translate.instant('action_cancel'),
                detail_singleSignOnSettings_authenticationDisabled:
                  $translate.instant(
                    'detail_singleSignOnSettings_authenticationDisabled'
                  )
              }

              dialogs
                .confirm(
                  transl.title_changeAuthenticationMethod,
                  interpolatedStr,
                  {
                    size: 'md',
                    yes: transl.action_changeAuthentication,
                    no: transl.action_cancel
                  }
                )
                .result.then(function () {
                  SSOFactory.deleteSAMLConfig().then(function () {
                    logger.logSuccess(
                      transl.detail_singleSignOnSettings_authenticationDisabled
                    )
                    vm.config = null
                  }, ErrorService.processError)
                })
            })
        }

        function navigateToAddRoute() {
          return tsvApiConfig.getOrganizationTsv().then(
            function (response) {
              if (response.data.tsv.enabled) {
                dialogs.notify(
                  $translate.instant('title_singleSignOnSettings_disableMFA'),
                  $translate.instant('detail_singleSignOnSettings_disableMFA'),
                  {
                    size: 'md',
                    yes: $translate.instant('action_ok')
                  }
                )
              } else {
                $location.path(UserService.buildUrl('/settings/sso/add'))
              }
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }

        init()
      }
    )
})()
